module.exports = __webpack_public_path__ + "static/purple_cone_flower_16x20-13c1d57007ad7b81217256e030f5555a.jpg";